const LoaderComp = () => {
  return (
    <div className="fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="h-16 w-16 animate-spin rounded-full border-y-2 border-gray-300"></div>
    </div>
  );
};
export default LoaderComp;
